<template>
    <div class="pop_up_layer find_account" @click="closeModal"></div>
    <div
        class="pop_detail event_pop_up speak_campaign"
        :class="{
            mobile: state.isMobile,
            main: state.step === 0,
            content: state.step > 0 && state.step < 4,
            comment: state.step === 4,
            complete: state.step > 4,
        }"
    >
        <div class="head">
            <p>{{ props.title }}</p>
            <button class="close_btn" @click="closeModal">
                <img src="@/assets/closeBtn.png" alt="닫기" />
            </button>
        </div>

        <div class="event_content_wrap">
            <Event v-model:step="state.step" @complete="complete"></Event>
        </div>
        <div class="bottom">
            <img class="logo" src="@/assets/eventModalLogo.png" v-if="state.step === 0 || state.step === 4" alt="" />
            <img class="logo" src="@/assets/eventModalLogo_wh.png" v-else alt="" />
        </div>
    </div>
</template>

<script lang="ts" config>
    import { reactive, onMounted, CommonUtils, ModalDefault, ref } from "@/BaseComponent";
    import Event from "./raisingAwareness/default.vue";

    export default {
        props: {
            title: {
                type: String,
                default: "",
            },
        },
        emits: ["close", "callback"],
        components: { Event },
        setup(props: any, { emit }: any) {
            const state = reactive({
                title: "" as string,
                content: "" as string,
                step: 0 as number,

                isMobile: false as boolean,
            });

            const modal = reactive({
                tab: 0,
                action: 0,
                title: "",
                content: "",
            });

            onMounted(() => {
                document.body.style.overflow = "hidden";
            });

            const closeModal = () => {
                emit("close");
                document.body.style.overflow = "";
                document.body.style.pointerEvents = "";
            };

            const complete = (eventData: any) => {
                const param = { action: "eventComplete", eventData };
                emit("callback", param);
            };

            return {
                props,
                state,
                modal,
                closeModal,
                CommonUtils,
                complete,
            };
        },
    };
</script>
